import script from "./KinderWert.vue?vue&type=script&setup=true&lang=js"
export * from "./KinderWert.vue?vue&type=script&setup=true&lang=js"

import "./KinderWert.vue?vue&type=style&index=0&id=861ed14c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-861ed14c"]])

export default __exports__